/* eslint-disable no-empty-pattern */
import {createReducer, createActions} from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */
const {Types, Creators} = createActions({
  publicationCreateRequest: ['id'],
  publicationCreateSuccess: ['result'],

  deletePublicationCreateRequest: ['id', 'data'],
  deletePublicationCreateSuccess: ['deletePublicationCreateResult', 'postId'],
  deletePublicationCreateReset: null,

  savePublicationCreateRequest: ['id', 'data'],
  savePublicationCreateSuccess: ['result'],
  savePublicationCreateReset: null,

  saveSellerRequest: ['id', 'data'],
  saveSellerSuccess: ['saveResult'],

  updateSellerRequest: ['id', 'data'],
  updateSellerSuccess: ['updateResult'],

  deleteSellerRequest: ['id'],
  deleteSellerSuccess: ['deleteId'],
  sellerReset: null,

  saveSupplierRequest: ['id', 'data'],
  saveSupplierSuccess: ['saveResult'],
  updateSupplierRequest: ['id', 'data'],
  updateSupplierSuccess: ['updateResult'],
  deleteSupplierRequest: ['id'],
  deleteSupplierSuccess: ['deleteId'],
  supplierReset: null,

  saveMediaRequest: ['id', 'data'],
  saveMediaSuccess: ['saveResult'],
  updateMediaRequest: ['id', 'data'],
  updateMediaSuccess: ['updateResult'],
  deleteMediaRequest: ['id'],
  deleteMediaSuccess: ['deleteId'],

  publicationCreateReset: null,

  publicationCreateFetchingReset: null,
})

export const PublicationCreateTypes = Types
export default Creators

/* ------------- Initial State ------------- */
export const INITIAL_STATE = Immutable({
  result: null,
  fetching: false,

  savePublicationCreateResult: null,
  savePublicationCreateFetching: false,

  deletePublicationCreateResult: null,
  deletePublicationCreateFetching: false,

  sellerResult: null,
  sellerFetching: false,

  supplierResult: false,
  supplierFetching: false,

  saveMediaFetching: false,
  updateMediaFetching: false,
  deleteMediaFetching: false,
})

/* ------------- Selectors ------------- */
export const PublicationCreateSelectors = {
  getState: state => state.publicationCreate,
}

/* ------------- Reducers ------------- */

export const publicationCreateRequest = (state, {id}) => {
  return state.merge({fetching: true})
}

export const publicationCreateSuccess = (state, {result}) => {
  return state.merge({fetching: false, result})
}

export const savePublicationCreateRequest = (state, {id, data}) => {
  return state.merge({savePublicationCreateFetching: true})
}

export const savePublicationCreateSuccess = (state, {result}) => {
  return state.merge({savePublicationCreateFetching: false, result})
}

export const deletePublicationCreateRequest = (state, {id, data}) => {
  return state.merge({deleteListPublicationFetching: true})
}

export const deletePublicationCreateSuccess = (state, {deletePublicationCreateResult, postId}) => {
  return state.merge({deletePublicationCreateFetching: false, deletePublicationCreateResult})
}

export const deletePublicationCreateReset = (state, {}) => {
  return state.merge({deletePublicationCreateFetching: false, deletePublicationCreateResult: null})
}

export const saveSellerRequest = (state, {id, data}) => {
  return state.merge({sellerFetching: true})
}

export const saveSellerSuccess = (state, {saveResult}) => {
  return state.merge({
    result: {
      ...state.result,
      seller: [...state.result.seller, {...saveResult}],
    },
    sellerResult: saveResult,
    sellerFetching: false,
  })
}

export const updateSellerRequest = (state, {id, data}) => {
  return state.merge({sellerFetching: true})
}

export const updateSellerSuccess = (state, {updateResult}) => {
  return state.merge({
    result: {
      ...state.result,
      seller: [...state.result.seller.map(seller => (seller.id === updateResult.id ? {...updateResult} : {...seller}))],
    },
    sellerResult: updateResult,
    sellerFetching: false,
  })
}

export const deleteSellerRequest = (state, {id}) => {
  return state.merge({sellerFetching: true})
}

export const deleteSellerSuccess = (state, {deleteId}) => {
  return state.merge({
    result: {
      ...state.result,
      seller: [...state.result.seller.filter(seller => seller.id !== deleteId)],
    },
    sellerResult: true,
    sellerFetching: false,
  })
}

export const sellerReset = (state, {}) => {
  return state.merge({
    sellerResult: null,
    sellerFetching: false,
  })
}

export const saveSupplierRequest = (state, {id, data}) => {
  return state.merge({supplierFetching: true})
}

export const saveSupplierSuccess = (state, {saveResult}) => {
  return state.merge({
    result: {
      ...state.result,
      supplier: [...state.result.supplier, {...saveResult}],
    },
    supplierResult: saveResult,
    supplierFetching: false,
  })
}

export const updateSupplierRequest = (state, {id, data}) => {
  return state.merge({supplierFetching: true})
}

export const updateSupplierSuccess = (state, {updateResult}) => {
  return state.merge({
    result: {
      ...state.result,
      supplier: [...state.result.supplier.map(supplier => (supplier.id === updateResult.id ? {...updateResult} : {...supplier}))],
    },
    supplierResult: updateResult,
    supplierFetching: false,
  })
}

export const deleteSupplierRequest = (state, {id}) => {
  return state.merge({supplierFetching: true})
}

export const deleteSupplierSuccess = (state, {deleteId}) => {
  return state.merge({
    result: {
      ...state.result,
      supplier: [...state.result.supplier.filter(supplier => supplier.id !== deleteId)],
    },
    supplierResult: true,
    supplierFetching: false,
  })
}

export const supplierReset = (state, {}) => {
  return state.merge({
    supplierResult: null,
    supplierFetching: false,
  })
}

/**/

export const saveMediaRequest = (state, {id, data}) => {
  return state.merge({saveMediaFetching: true})
}

export const saveMediaSuccess = (state, {saveResult}) => {
  return state.merge({
    result: {...state.result, media: [...state.result.media, {...saveResult}]},
    saveMediaFetching: false,
  })
}

export const updateMediaRequest = (state, {id, data}) => {
  return state.merge({updateMediaFetching: true})
}

export const updateMediaSuccess = (state, {updateResult}) => {
  return state.merge({updateMediaFetching: false})
}

export const deleteMediaRequest = (state, {id}) => {
  return state.merge({deleteMediaFetching: true})
}

export const deleteMediaSuccess = (state, {deleteId}) => {
  const newMediaList = state.result.media.filter(el => el.id !== deleteId)
  return state.merge({
    result: {...state.result, media: newMediaList},
    deleteMediaFetching: false,
  })
}

/**/

export const publicationCreateReset = state => {
  return INITIAL_STATE
}

export const publicationCreateFetchingReset = state => {
  return state.merge({
    fetching: false,
    savePublicationCreateFetching: false,
    deletePublicationCreateFetching: false,

    sellerFetching: false,
    supplierFetching: false,
  })
}

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.PUBLICATION_CREATE_REQUEST]: publicationCreateRequest,
  [Types.PUBLICATION_CREATE_SUCCESS]: publicationCreateSuccess,

  [Types.SAVE_PUBLICATION_CREATE_REQUEST]: savePublicationCreateRequest,
  [Types.SAVE_PUBLICATION_CREATE_SUCCESS]: savePublicationCreateSuccess,

  [Types.PUBLICATION_CREATE_RESET]: publicationCreateReset,

  [Types.PUBLICATION_CREATE_FETCHING_RESET]: publicationCreateFetchingReset,

  [Types.DELETE_PUBLICATION_CREATE_REQUEST]: deletePublicationCreateRequest,
  [Types.DELETE_PUBLICATION_CREATE_SUCCESS]: deletePublicationCreateSuccess,
  [Types.DELETE_PUBLICATION_CREATE_RESET]: deletePublicationCreateReset,

  [Types.SAVE_SELLER_REQUEST]: saveSellerRequest,
  [Types.SAVE_SELLER_SUCCESS]: saveSellerSuccess,

  [Types.UPDATE_SELLER_REQUEST]: updateSellerRequest,
  [Types.UPDATE_SELLER_SUCCESS]: updateSellerSuccess,

  [Types.DELETE_SELLER_REQUEST]: deleteSellerRequest,
  [Types.DELETE_SELLER_SUCCESS]: deleteSellerSuccess,

  [Types.SELLER_RESET]: sellerReset,

  [Types.SAVE_SUPPLIER_REQUEST]: saveSupplierRequest,
  [Types.SAVE_SUPPLIER_SUCCESS]: saveSupplierSuccess,

  [Types.UPDATE_SUPPLIER_REQUEST]: updateSupplierRequest,
  [Types.UPDATE_SUPPLIER_SUCCESS]: updateSupplierSuccess,

  [Types.DELETE_SUPPLIER_REQUEST]: deleteSupplierRequest,
  [Types.DELETE_SUPPLIER_SUCCESS]: deleteSupplierSuccess,

  [Types.SUPPLIER_RESET]: supplierReset,

  [Types.SAVE_MEDIA_REQUEST]: saveMediaRequest,
  [Types.SAVE_MEDIA_SUCCESS]: saveMediaSuccess,

  [Types.UPDATE_MEDIA_REQUEST]: updateMediaRequest,
  [Types.UPDATE_MEDIA_SUCCESS]: updateMediaSuccess,

  [Types.DELETE_MEDIA_REQUEST]: deleteMediaRequest,
  [Types.DELETE_MEDIA_SUCCESS]: deleteMediaSuccess,
})
